import React from "react";

export interface IProps {
  isAtTopOfPage?: boolean;
  children: any;
  className?: string;
  dataTestId?: string;
}

export const CalculatorHeading = ({
  isAtTopOfPage = false,
  children,
  className,
  dataTestId,
}: IProps) => (isAtTopOfPage ? (
  <h1 className={className} data-testid={dataTestId}>
    {children}
  </h1>
) : (
  <h2 className={className} data-testid={dataTestId}>
    {children}
  </h2>
));
